module.exports = __webpack_public_path__ + "static/media/ic_video_off_disable.0ccaf85c.svg";